


















import Vue from "vue";
import QuestionInput from "./QuestionInput.vue";
export default Vue.extend({
  name: "Question",
  components: { QuestionInput },
  props: ["value", "horizontal", "light"],
  data() {
    return {
      result: this.value
    };
  },
  methods: {
    updateVal() {
      this.$emit("input", this.value);
    }
  }
});
